import { render, staticRenderFns } from "./VoteRecord.vue?vue&type=template&id=70ce1554&scoped=true&"
import script from "./VoteRecord.vue?vue&type=script&lang=js&"
export * from "./VoteRecord.vue?vue&type=script&lang=js&"
import style0 from "./VoteRecord.vue?vue&type=style&index=0&id=70ce1554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce1554",
  null
  
)

export default component.exports